import { render, staticRenderFns } from "./LessonResourceItemBase.vue?vue&type=template&id=34099b58&scoped=true&"
import script from "./LessonResourceItemBase.vue?vue&type=script&lang=js&"
export * from "./LessonResourceItemBase.vue?vue&type=script&lang=js&"
import style0 from "./LessonResourceItemBase.vue?vue&type=style&index=0&id=34099b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34099b58",
  null
  
)

export default component.exports